import { z } from 'zod';
import { expectType, zDocument } from './model.js';
export const zTelemetry = zDocument.extend({
    type: z.literal('telemetry'),
    user: z.string(),
    actionType: z.string(),
    actionTarget: z.string(),
    localDateTime: z.string(),
    data: z.record(z.union([z.string(), z.number(), z.boolean()])).optional()
});
expectType({});
expectType({});
export const EmptyTelemetry = {
    _id: '',
    _rev: '',
    created: '',
    updated: '',
    type: 'telemetry',
    user: '',
    actionType: '',
    actionTarget: '',
    localDateTime: ''
};
